import React from "react";
import {toJS} from "mobx";
import {observer} from "mobx-react";

import {DatePicker,Row,Col,Input,Select,Radio, AutoComplete,Button} from "antd";
import {exportFile} from '@src/Utils';
import breadcrumb_store from '@src/Store/Common/MyBreadcrumb';

import moment from 'moment';

import MySearchComponent from '@ViewsDashboard/Common/MySearchComponent';
import GoToPage from '@common/GoToPage';

import Giveaway_store,{pagination_store,filter_store,GiveawayItemStore} from '@store/Statistic/GiveawayLog/GiveawayLogStore';

const { RangePicker } = DatePicker;

@observer
class GiveawayLogFilterForm extends React.Component
{
    render() {
        let numberStyle = {fontSize:'16px', fontWeight: '600', marginLeft: '15px', float: 'right'};
        let tipStyle    = {marginLeft:'3px', float: 'right'};
        let tipTitle        = '总赠送';
        let tipTitleName    = '总被赠送';
        let tipDonationName = '平台赠送';

        return (
            <Row type={"flex"} style={{flex:'1'}}>
                <Col  style={{lineHeight: '34px'}}>
                    <MySearchComponent
                        defaultValue={{
                            nick_name:filter_store.nick_name?filter_store.nick_name:'',
                            pet_name:filter_store.pet_name?filter_store.pet_name:'',
                            agent:filter_store.agent?filter_store.agent:'',
                            giveType:filter_store.giveType?filter_store.giveType:'',
                            search:filter_store.search?filter_store.search:'',
                            date:filter_store.start_time != undefined?[filter_store.start_time,filter_store.end_time]:[]
                        }}
                        onClick={(values)=> {
                            let agent = values.agent;
                            if (agent === '') agent = undefined
                            let giveType = values.pet_name;
                            if (giveType === '') giveType = undefined
                            let search = values.search;
                            if (search === '') search = undefined;
                            let filter = {
                                nick_name:filter_store.nick_name,
                                pet_name:filter_store.pet_name,
                                giveType:giveType,
                                agent:agent,
                                search:search,
                                type_time:values.type_time,
                            }
                            Giveaway_store.reloadDatas(filter);

                        }}
                    />
                </Col>
                <Col style={{lineHeight: '34px', marginLeft: '10px', flex: 1, textAlign: 'right'}}>
                    <span style={numberStyle}>{Number(Giveaway_store.sumOutMoney).toFixed(2)}</span>
                    <span style={tipStyle}>{tipTitleName}</span>
                    <span style={numberStyle}>{Number(Giveaway_store.sumInMoney).toFixed(2)}</span>
                    <span style={tipStyle}>{tipTitle}</span>
                    <span style={numberStyle}>{Number(Giveaway_store.sumDonationAmount).toFixed(2)}</span>
                    <span style={tipStyle}>{tipDonationName}</span>
                </Col>
            </Row>
        )
    }

}
export default GiveawayLogFilterForm;


// WEBPACK FOOTER //
// ./src/ViewsDashboard/Statistic/GiveawayLog/GiveawayLogFilterForm.jsx